import { useState } from "react";
import "./BotProfil.css";
import BotProfileCard from "./components/BotProfileCard/BotProfileCard";
import InputSearch from "/src/components/UI/InputSearch/InputSearch";

function BotProfil({ bots, loading, companyName }) {
    const [search, setSearch] = useState("");

    if (loading) {
        return <p className="bot-profil-empty">Loading bot profiles...</p>;
    }

    if (bots.length === 0) {
        return <p className="bot-profil-empty">No bot found for this company.</p>;
    }

    const filteredBots = bots.filter((bot) => bot.name.toLowerCase().includes(search));

    return (
        <>
            <div className="bot-profil-search">
                <InputSearch placeholderLibelle="bot name" onChange={(e) => setSearch(e.target.value.toLowerCase())} />
            </div>
            {filteredBots.length > 0 ? (
                <div className="bot-profil-grid">
                    {filteredBots.map((bot) => (
                        <BotProfileCard key={bot.id} bot={bot} companyName={companyName} />
                    ))}
                </div>
            ) : (
                <p className="bot-profil-empty">No bot matches "{search}".</p>
            )}
        </>
    );
}

export default BotProfil;
